export default {
  title: {
    en: "Contact Us",
    ja: "お問い合わせ"
  },
  anyQuestion: {
    en: "If you have any issues or questions please contact us.",
    ja: "問題や質問がある場合は、お問い合わせください。"
  },
  replayTime: {
    en: "You will get a reply within 10 working days",
    ja: "10営業日以内に返信いたします"
  },
  sendEmailButton: {
    en: "Send us an email",
    ja: "私たちにメールを送って"
  },
  askedQuestions: {
    en: "Frequently asked questions",
    ja: "よくある質問"
  }
}
